import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WhatsappRequestDto } from '../models/whatsapp-request-dto';
import { WhatsappResponseDto } from '../models/whatsapp-response-dto';

@Injectable({ providedIn: 'root' })
export class WhatsappMessageControllerV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation sendWhatsappMessage1
   */
  static readonly SendWhatsappMessage1Path = '/api/v1/sendMessage';

  /**
   * Send Message.
   *
   * This API is for send message thorugh the WhatsApp
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendWhatsappMessage1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendWhatsappMessage1$Response(params: {
    body: WhatsappRequestDto
  }
): Observable<StrictHttpResponse<WhatsappResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WhatsappMessageControllerV2Service.SendWhatsappMessage1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
        responseType: 'json',
        accept: 'application/json'
      })
    ).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WhatsappResponseDto>;
      })
    );
  }

  /**
   * Send Message.
   *
   * This API is for send message thorugh the WhatsApp
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendWhatsappMessage1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendWhatsappMessage1(params: {
    body: WhatsappRequestDto
  }
): Observable<WhatsappResponseDto> {
    return this.sendWhatsappMessage1$Response(params).pipe(
      map((r: StrictHttpResponse<WhatsappResponseDto>) => r.body as WhatsappResponseDto)
    );
  }

}
